export const COLORS = Object.freeze({
    // Primary Colors
    GRAY: '#54565a',
    BLUE: '#00b2e3',
    GREEN: '#1dcad3',
    RED: '#f5333f',
    YELLOW: '#f6d44d',
    NAVY: '#003871',
    // Secondary Colors
    GRAY_LIGHT: '#7f8083',
    GRAY_DRAK: '#000000',
    BLUE_LIGHT: '#40c5e9',
    BLUE_DARK: '#0069a7',
    GREEN_LIGHT: '#5bd7dd',
    GREEN_DARK: '#00758d',
    RED_LIGHT: '#f7646f',
    RED_DARK: '#c10230',
    YELLOW_LIGHT: '#f7de79',
    YELLOW_DARK: '#eba900',
    NAVY_LIGHT: '#466d94',
    NAVY_DARK: '#002856',
    // OTHERS
    NULL: '#dedede',
    WHITE: '#ffffff',
    ORANGE: '#EBA900',
});
